<template>
  <section v-if="species && links.length > 0 && isOnline">
    <v-divider vertical class="float-left mr-5"></v-divider>
    <h3 class="mb-5 text--secondary">Läs mer om {{ species.name_sve }}</h3>
    <div v-if="species">
      <ul>
        <li v-for="link in links" :key="link.id">
          <a target="_blank" :href="link.url">{{ link.name_sve }}</a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import Misc from '@/mixins/Misc.js'
import DataLayer from '@/store/SingleSpeciesDataLayer'
export default {
  name: 'SpeciesLinks',
  mixins: [Misc],
  props: {
    species: { type: Object, required: true }
  },
  data() {
    return {
      links: []
    }
  },
  created() {
    this.setup()
  },
  methods: {
    async setup() {
      try {
        const data = await DataLayer.GetLinksBySpecId(this.species.id)
        this.links = data
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  padding-left: 12px;
  list-style: none;
  margin-top: 0;
  margin-bottom: 10px;
}
li {
  position: relative;
  padding-left: 25px;
}
li:before {
  background: rgba(0, 0, 0, 0.3);
  width: 5px;
  height: 5px;
  content: '';
  display: block;
  position: absolute;
  top: 9px;
  left: 10px;
}
</style>
